'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triangle = undefined;
exports.iconSizeMixin = iconSizeMixin;

var _styledComponents = require('styled-components');

var _styleFunctions = require('../styleFunctions');

/**
 * Icon size mixin
 */
function iconSizeMixin(height) {
  var imgHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
  var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : height;
  var imgWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : imgHeight;

  return (0, _styledComponents.css)(['     &,& > *{width:', ';height:', ';line-height:', ' !important;align-items:center;justify-content:center;', '}svg{width:', ';height:', ';}'], width, height, height, imgHeight && imgHeight !== 'inherit' && 'background-size: ' + imgHeight + ';', imgWidth, imgHeight);
}

/**
 * Generate triangle
 * @param {string} direction - triangle direction
 * @param {string} [color='currentcolor'] - triangle color
 * @param {number} [width=1] - triangle width
 * @param {number} [height=width/2] - triangle height
 * @param {string} [unit='em'] - size unit
 */
var triangle = exports.triangle = function triangle(direction) {
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'currentcolor';
  var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : width / 2;
  var unit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'em';

  var perpendicularBorder = height + ' solid transparent';

  return '\n    width: 0;\n    height: 0;\n    \n    border-' + (0, _styleFunctions.oppositeDirection)(direction.toLowerCase()) + ':\n      ' + (height + unit) + ' solid $color;\n    border-' + direction + ': 0 solid transparent;\n    \n    ' + (direction.toLowerCase() === 'top' || direction.toLowerCase() === 'bottom' ? '\n        border-left:   ' + perpendicularBorder + ';\n        border-right:  ' + perpendicularBorder + ';\n      ' : '\n        border-top:   ' + perpendicularBorder + ';\n        border-bottom:  ' + perpendicularBorder + ';\n      ') + '    \n  ';
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/mixins/mixinsElements.js
// module id = 629
// module chunks = 0